module.exports = __webpack_public_path__ + "img/DesktopMenuTile-active.1332eabe.svg";